import moment from 'moment';

export default function genererCritereRecherchePaiementSurFacture() {
  return {
    agencesId: [],
    agencesIds: [],
    dates: {
      dateDebut: (moment().startOf('month')).toDate(),
      dateFin: (moment().endOf('month')).toDate(),
    },
    code: '',
    validateurs: [],
    themeFacture: null,
    codeAndReferenceFacture: null,
    codeDossierFacture: null,
    bonAPayer: null,
    commentaire: null,
    auto: null,
    societeId: null,
    montant: null,
    nomBailleur: null,
    referencePaiement: null,
    modesReglementsIds: [],
    blocageReglement: null,
  };
}
